import './anchor-links-block.scss';
import './anchor-links-block.html.twig';

export default function () {
  const block = document.querySelector('.anchor-links-block');
  if (!block) {
    return;
  }
  const dropDown = block.querySelector('.anchor-links-block__dropdown');
  const linksContainer = block.querySelector('.anchor-links-block__links-container');

  const open = () => {
    dropDown.setAttribute('aria-expanded', 'true');
    linksContainer.classList.add('anchor-links-block__links-container--open');
  };

  const close = () => {
    dropDown.setAttribute('aria-expanded', 'false');
    linksContainer.classList.remove('anchor-links-block__links-container--open');
  };

  dropDown.addEventListener('click', (event) => {
    const el = event.target;
    if (el.getAttribute('aria-expanded') === 'false') {
      open();
    } else {
      close();
    }
  });

  const links = block.querySelectorAll('.anchor-links-block__link');
  Array.from(links).forEach((link) => {
    link.addEventListener('click', () => {
      close();
    });
  });
}
